import React from 'react';
import S from './Footer.module.css'

import footerLogo from '../../assets/images/footer/footerLogo.png'
import footerCert from '../../assets/images/footer/footerCert.png'

const Footer = () => {

  const goPopup = (url) => () => {
    const options = 'width=980, height=700, scrollbars=yes, resizable=no';
    window.open(url, "_blank", options);
  }
  
  const selectChange = (e) => {
    const url = e.target.value;
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <div className='flex-column'>
      <div id={S.footerWrap}>
        <div className={S.footerLogo}>
          <img src={footerLogo} alt='logo'/>
        </div>
        <div id={S.footerContentWrap}>
          <div id={S.footerMenu}>
            <span className='cursor'><a href='http://emfoplus.co.kr/index.do' target='_blank'>회사소개</a></span>
            <span className='cursor' onClick={goPopup('http://privacy.emfo.co.kr/06_rfemfo/privacy.emfo?pg=2')}><a>개인정보처리방침</a></span>
            <span className='cursor' onClick={goPopup('http://privacy.emfo.co.kr/06_rfemfo/privacy.emfo?pg=1')}>이용약관</span>
            <select className={S.footerSelect} onChange={selectChange} defaultValue=''>
              <option value='' disabled>패밀리사이트</option>
              <option value='http://emfoplus.co.kr'>엠포플러스</option>
              <option value='http://bizemfo.co.kr'>기업형 메시지 서비스</option>
              <option value='https://smsshot.co.kr'>개인형 메시지 서비스</option>
              <option value='https://onevote.co.kr'>선거문자 한표문자</option>
              <option value='https://moacard.co.kr'>세상의모든카드 모아카드</option>
              <option value='http://ochart.co.kr'>조직도제작소 오차트</option>
              <option value='https://ikeeps.co.kr'>출결관리솔루션 아이킵스</option>
              <option value='https://sensetab.co.kr'>RFID/NFC전문리더 센스탭</option>
            </select>
          </div>
          <div id={S.footerContent}>
            엠포플러스(주) 주소 : 서울시 성동구 아차산로 17길 48 SK V1센터 1동 16F (04799) <br />
            대표이사 : 이정훈 고객센터:1599-2320 <br />
            팩스 : 02-6442-0198 이메일 : rfid@emfoplus.co.kr 사업자등록번호 : 206-86-34586 통신판매업신고 : 제 2020-서울성동-02947 호 <br />
            Copyright(c) emfoplus.co.kr All right reserved
          </div>
        </div>
      </div>
      <div id={S.footerCert}>
        <img src={footerCert} alt='cert'/>
      </div>
    </div>
  );

};

export default Footer;
